module.exports = __webpack_public_path__ + "static/HR Smartphone App AbaClik Meine Mitarbeiter-90e426337502f7d0cc6723aaf00db394.png";